export const getArrMinMax = (arr: number[]): [number, number] => {
  return [Math.min(...arr), Math.max(...arr)]
}
